




import Vue from "vue";

interface Props {
  /** IfaceSyncStatus enum érték (a szín ez alapján dől el) */
  status: number;
  /** Megjelenítendő szöveg (a backendről jövő név) */
  name: string;
  /**
   * Opcionális háttérszín, ami felülírja a státusz-alapú színt — ott kell, ahol a státusz-kódok
   * nem az IfaceSyncStatus jelentését hordozzák (pl. a Verk köztes táblákon az 5 = API-hiba, nem Kihagyva).
   */
  color: string;
}

interface Computed {
  cssClass: string;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "SyncStatusBadge",

  props: {
    status: { type: Number, required: true },
    name: { type: String, default: "" },
    color: { type: String, default: "" },
  },

  computed: {
    cssClass(): string {
      // IfaceSyncStatus enum: 1=None, 2=InProgress, 3=Done, 4=Error, 5=Skip
      switch (this.status) {
        case 2: return "status-in-progress";
        case 3: return "status-done";
        case 4: return "status-error";
        case 5: return "status-skip";
        default: return "";
      }
    },
  },
});
